import React from "react";
import Diploma from "../../../assets/images/fi-rr-diploma.svg";
import PdfFileImage from "../../../assets/images/pdfFile.png";
import { DATE_FORMAT3 } from "../../../constants/stringConstants";
import { DateFormatter, openImageInBrowser } from "../../../functions/commons";
import { Image } from "antd";
import ModeEditOutlineOutlinedIcon from '@mui/icons-material/ModeEditOutlineOutlined';
import { isEmpty, isNil } from "lodash";


function CoursesDiv({ certificate,onEdit }) {
  return (
    <>
      <div className="c2-courses-div__logo-text-img">
        <img src={Diploma} alt="diploma" />
        <div className="c2cd-logo-text-img__text-img">
        <div style={{display:'flex'}}>

          {certificate?.nameOfCertificate &&(
            <h3>{certificate?.nameOfCertificate} </h3>
          )
         }
            <div onClick={()=>onEdit(certificate)} className="edit_icon" style={{marginLeft:'40px'}}><ModeEditOutlineOutlinedIcon style={{height:'20px',width:'20px'}}/> </div>

</div>
          {certificate?.institute && (
            <h4>{certificate?.institute}</h4>
          )}

          <p>
            {`${DateFormatter(certificate.from,DATE_FORMAT3)} - ${DateFormatter(certificate.to,DATE_FORMAT3)}`}
          </p>
     
          {/* <div className="c2cdlti-text-img__img-div-container">
            {
              certificate?.certificateImage && (
                <CourseFiles
                  certificateLetter={certificate?.certificateImage}
                />
              )
              //  :
              //  <Skeleton  width={73} height={55}/>
            }
          </div> */}
                  {!isNil(certificate.certificateImage)&&!isEmpty(certificate.certificateImage) && <Image src={PdfFileImage} style={{height:'70px',width:'70px'}} preview={false} onClick={()=>openImageInBrowser(certificate.certificateImage)}/>}

        </div>

      </div>
    </>
  );
}

export default CoursesDiv;
